// extracted by mini-css-extract-plugin
module.exports = {"property-details":"PropertyDetails_property-details__3ZsTE","property-details__more":"PropertyDetails_property-details__more__1uLeE"};